import { defineSlotRecipe } from '@chakra-ui/react';
import { ratingGroupAnatomy } from '@chakra-ui/react/anatomy';

import { ratingDefaultSize, ratingItemGap } from './rating.kds';

/**
 * KDS Rating overrides Chakra's `ratingGroup` slot recipe.
 * Empty stars use `neutral.200`; filled use `colorPalette.solid` (brand by default).
 */
export const ratingSlotRecipe = defineSlotRecipe({
  className: 'ks-rating-group',
  slots: ratingGroupAnatomy.keys(),
  base: {
    root: {
      display: 'inline-flex',
    },
    control: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: ratingItemGap,
    },
    item: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      userSelect: 'none',
    },
    itemIndicator: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '1em',
      height: '1em',
      position: 'relative',
      '--clip-path': { base: 'inset(0 50% 0 0)', _rtl: 'inset(0 0 0 50%)' },
      _icon: {
        stroke: 'currentColor',
        width: '100%',
        height: '100%',
        display: 'inline-block',
        flexShrink: 0,
        position: 'absolute',
        left: 0,
        top: 0,
      },
      '& [data-bg]': {
        color: 'neutral.200',
      },
      '& [data-fg]': {
        color: 'transparent',
      },
      '&[data-highlighted]:not([data-half])': {
        '& [data-fg]': {
          color: 'colorPalette.solid',
        },
      },
      '&[data-half]': {
        '& [data-fg]': {
          color: 'colorPalette.solid',
          clipPath: 'var(--clip-path)',
        },
      },
    },
    label: {
      textStyle: 'default.medium',
      color: 'neutral.500',
    },
  },
  variants: {
    size: {
      xs: {
        item: {
          textStyle: 'sm',
        },
      },
      sm: {
        item: {
          textStyle: 'md',
        },
      },
      md: {
        item: {
          textStyle: 'xl',
        },
      },
      lg: {
        item: {
          textStyle: '2xl',
        },
      },
    },
  },
  defaultVariants: {
    size: ratingDefaultSize,
  },
});
